import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { codeBlock } from '../assets';
import {
  Typography,
  Grid,
  Link,
  InformationCard,
  MaterialIcon,
  SvgIcon,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import useAsync from 'react-use/esm/useAsync';
import { useComponentEntity } from '@dewise-devex/backstage-plugin-utilities-common-client';

export const Ownership = () => {
  const { entity } = useEntity();
  const componentService = useComponentEntity();

  const {
    value: productComponents = [],
    loading,
    error,
  } = useAsync(() => componentService.byOwner(entity), [entity]);

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <div>{error}</div>;

  return (
    <InformationCard
      as="custom"
      HeaderComponent={
        <>
          <div>
            <Typography style={{ marginBottom: '12px' }} variant="titleMD">
              Ownership
            </Typography>
          </div>
          <div>
            <Link href="#">
              <MaterialIcon.groups2 />
              <Typography variant="labelLG" title="Owner">
                Research and Development
              </Typography>
            </Link>
          </div>
        </>
      }
    >
      <div>
        {productComponents.length > 0 ? (
          productComponents.map(product => (
            <div key={product.metadata.name}>
              <div>
                <img src={codeBlock} />
                <Typography variant="titleMD">
                  {product.metadata.name}
                </Typography>
              </div>
              <Typography variant="bodySM">
                {product.metadata.description}
              </Typography>
              <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 3 }}>
                  <Typography>Tech Docs</Typography>
                  <Link href="#">
                    <SvgIcon.MenuBookUnshaded />
                  </Link>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                  <Typography>Source Code</Typography>
                  <Link href="#">
                    <MaterialIcon.github />
                  </Link>
                </Grid>
              </Grid>
            </div>
          ))
        ) : (
          <div>No products found.</div>
        )}
      </div>
    </InformationCard>
  );
};
